import React from "react";
import { Global } from "@emotion/core";
import globalStyles from "../utils/globalStyles";
import { Router } from "@reach/router";

import Main from "./layout/Main";
import Products from "./products/Products";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import NotFound from "./notfound";

function App() {
  return (
    <div>
      <Global styles={globalStyles} />
      <Header />
      <Router>
        <Main path="/" />
        <Products path="products" />
        <NotFound default />
      </Router>
      <Footer />
    </div>
  );
}

export default App;
